//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createAction } from '@utils/actions';

import { BULK_ACTIONS_ACTIONS } from 'app/bulk-actions/bulk-actions-constants/bulk-actions-constants';

// created outside of angular context so it can be used in other redux actions
export function clearItems() {
  return createAction({
    type: BULK_ACTIONS_ACTIONS.CLEAR_SELECTED_ITEMS,
  });
}
